// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3hHRs","footer":"ChangeClinic_footer__4DM27"};